export const feesData = {
  "Beginners Class 1": {
    "Yearly": { numStudents: 1, fee: { NGN: 170000, USD: 111, GBP: 90, EUR: 100 } },
    "Monthly": { numStudents: 1, fee: { NGN: 15000, USD: 10, GBP: 8, EUR: 10 } },
  },
  "Beginners Class 2": {
    "Yearly": { numStudents: 1, fee: { NGN: 170000, USD: 111, GBP: 90, EUR: 100 } },
    "Monthly": { numStudents: 1, fee: { NGN: 15000, USD: 10, GBP: 8, EUR: 10 } },
  },
  "Beginners Class 3": {
    "Yearly": { numStudents: 1, fee: { NGN: 170000, USD: 111, GBP: 90, EUR: 100 } },
    "Monthly": { numStudents: 1, fee: { NGN: 15000, USD: 10, GBP: 8, EUR: 10 } },
  },
  "Idaadiy'": {
    "Yearly": { numStudents: 1, fee: { NGN: 206000, USD: 134, GBP: 106, EUR: 130 } },
    "Monthly": { numStudents: 1, fee: { NGN: 18000, USD: 12, GBP: 10, EUR: 12 } },
  },
  "Kiddies Class 1": {
    "Weekdays Monthly": { numStudents: 1, fee: { NGN: 8000, USD: 6, GBP: 5, EUR: 6 } },
    "Weekend Monthly": { numStudents: 1, fee: { NGN: 20000, USD: 13, GBP: 21, EUR: 13 } },
    "Weekdays & Weekend Monthly": { numStudents: 1, fee: { NGN: 26000, USD: 18, GBP: 15, EUR: 18 } },
  },
  "Kiddies Class 2": {
    "Weekdays Monthly": { numStudents: 1, fee: { NGN: 8000, USD: 6, GBP: 5, EUR: 6 } },
    "Weekend Monthly": { numStudents: 1, fee: { NGN: 20000, USD: 13, GBP: 21, EUR: 13 } },
    "Weekdays & Weekend Monthly": { numStudents: 1, fee: { NGN: 26000, USD: 18, GBP: 15, EUR: 18 } },
  },
  "Kiddies Class 3": {
    "Weekdays Monthly": { numStudents: 1, fee: { NGN: 8000, USD: 6, GBP: 5, EUR: 6 } },
    "Weekend Monthly": { numStudents: 1, fee: { NGN: 20000, USD: 13, GBP: 21, EUR: 13 } },
    "Weekdays & Weekend Monthly": { numStudents: 1, fee: { NGN: 26000, USD: 18, GBP: 15, EUR: 18 } },
  },
  "Family Class": {
    "Group of 3": { numStudents: 3, fee: { NGN: 75000, USD: 50, GBP: 47.5, EUR: 47.5 } },
    "Group of 6": { numStudents: 6, fee: { NGN: 150000, USD: 100, GBP: 95, EUR: 95 } },
  },
  "Private Class": {
    "Once Weekly": { numStudents: 1, fee: { NGN: 18000, USD: 12, GBP: 10, EUR: 12 } },
    "Twice Weekly": { numStudents: 1, fee: { NGN: 36000, USD: 24, GBP: 19, EUR: 24 } },
    "Thrice Weekly": { numStudents: 1, fee: { NGN: 54000, USD: 35, GBP: 28, EUR: 34 } },
    "Four Times Weekly": { numStudents: 1, fee: { NGN: 72000, USD: 47, GBP: 38, EUR: 46 } },
  },
  "Tahfeedh Class": {
    "General Monthly": { numStudents: 1, fee: { NGN: 18000, USD: 12, GBP: 10, EUR: 12 } },
    "General Per Semester": { numStudents: 1, fee: { NGN: 70000, USD: 46, GBP: 37, EUR: 44 } },
    "Private Once Weekly": { numStudents: 1, fee: { NGN: 9000, USD: 6, GBP: 5, EUR: 6 } },
    "Private Twice Weekly": { numStudents: 1, fee: { NGN: 18000, USD: 12, GBP: 10, EUR: 12 } },
    "Private Thrice Weekly": { numStudents: 1, fee: { NGN: 27000, USD: 17, GBP: 14, EUR: 17 } },
    "Private Four Times Weekly": { numStudents: 1, fee: { NGN: 36000, USD: 24, GBP: 19, EUR: 24 } },
    "Private Five Times Weekly": { numStudents: 1, fee: { NGN: 45000, USD: 30, GBP: 24, EUR: 30 } },
  },
};
